@if (data.view === 'errorAtUploadFile') {
  <div>
    <div class="dialog-container">
      <img src="../../../../../../assets/img/red_alert.svg" alt="Alert" />
      <p class="error-message">
        <q>{{ data.fileName }}</q>
      </p>
      <p class="error-message">{{ data.desc1 }}</p>
      <p>{{ data.desc2 }}</p>
    </div>
    <div class="dialog-footer">
      <button id="doneBtn" mat-flat-button class="mat-primary mat-flat-button" (click)="close()">Done</button>
    </div>
  </div>
}

@if (data.view === 'uploadingFile') {
  <div>
    <div class="dialog-container">
      <div class="content change-password-dialog">
        <div class="dialog-header">
          <h1 class="title mt-0">{{ data.title }}</h1>
          <div class="title-underline mt-2 float-left"></div>
          <p class="title-desc mt-6">{{ data.desc }}</p>
        </div>
        <div class="spinner-container">
          <mat-progress-spinner class="example-margin file-loader-spinner current-file-status" [strokeWidth]="6" [diameter]="100" [mode]="activeSpinner.mode" [value]="activeSpinner.value"> </mat-progress-spinner>
          <mat-progress-spinner class="example-margin file-loader-spinner default-file-status" [strokeWidth]="6" [diameter]="100" [mode]="filledSpinner.mode" [value]="filledSpinner.value"> </mat-progress-spinner>
        </div>
      </div>
    </div>
  </div>
}
